
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/insurance",
      function () {
        return require("private-next-pages/products/insurance/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/insurance"])
      });
    }
  